module.exports = __webpack_public_path__ + "static/puhumalla_parempaa_seksia-140x140-6371.cdd18b59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/puhumalla_parempaa_seksia-140x140-6371.jpg
// module id = 839
// module chunks = 129563053867776